import React from 'react'
import $ from 'jquery';
import {Link} from "react-router-dom";
import {LazyLoadImage} from "react-lazy-load-image-component";
import StaticHeader from '../StaticHeader'
import Chat from "../FaqChat/chat";
import {isMobileDevice} from "../commons/CommonFunctions";

class HeaderLanding extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pathname:''
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if((window.location.pathname === '/message' || window.location.pathname === '/message-user') && isMobileDevice()){
            this.setState({
                pathname:'message'
            })
        }
    }

    componentDidMount() {
        window.$(".extChatContainer")
            .stop()
            .animate({ scrollTop: window.$(".extChatContainer")[0].scrollHeight, }, 300);
        window.$('#header .iCross').hide();
        window.$("#header .iHamburger").on('click', function (event) {
            window.$('.leftpanel').addClass('navactive');
            window.$('.dgcontainer').addClass('navactive');
            window.$('.staticPage').addClass('navactive');
            window.$('#header .iHamburger').hide();            
            window.$('#header .iCross').show();
        });
        $("body, html").on('click', function (event) {
            if (!$(event.target).closest('#header .iHamburger, .read-more-less-btn').length) {
                $('.leftpanel').removeClass('navactive');
                $('.dgcontainer').removeClass('navactive');
                window.$('.staticPage').removeClass('navactive');
                $('.dropdown-menu.show').removeClass('show');
                window.$('#header .iHamburger').show();            
                window.$('#header .iCross').hide();
            }
        });
        window.$('.topDropdownMob .dropdown > a').on("click", function (e) {
            // var submenu = $(this);
            // $('.topDropdownMob .dropdown-menu').removeClass('show');
            // submenu.next('.topDropdownMob .dropdown-menu').addClass('show');
            e.stopPropagation();
            $(this).next('.dropdown-menu').toggleClass('show');
        });
    }

    render() {
        return <>
            <header className="bk_hdr" id="header">
                <div className="frdsktopwithoutsticky">
                    <div className="container">
                        {/* <div className="bkleftmnu d-none d-lg-block col-md-4">
                            <ul>
                                <li><Link to="/explore">Explore</Link></li>
                                <li><Link to="/causes">Causes</Link></li>
                            </ul>
                        </div> */}
                        <div className="bkcentermnu d-none d-lg-block col-md-4">                            
                            {/* <img
                                effect="blur"
                                src={"https://cdn.dscovr.com/images/logoWeNaturalists.svg"}
                                width="215px" alt="WeNaturalists"/>                             */}
                        </div>
                        <div className="bkrightmnu d-none d-lg-block col-md-4">
                            <ul style={{float: 'right'}}>
                                <li><Link to="/explore">Explore</Link></li>
                                <li><a href="/about-us">About Us</a></li>
                                <li><Link to="/how-it-works">How It Works</Link></li>
                                {/* <li><Link to="/login">Login</Link></li>
                                <li><Link to="/signup" className="hdrsignup">Sign Up</Link></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="container-fluid d-lg-none nologinpage">
                        <div className="row">
                            <div className="col-md-3 col-lg-3 logowrap">
                                <div className="logotop">
                                    <LazyLoadImage
                                        effect="blur"
                                        src={"https://cdn.dscovr.com/images/logoWeNaturalists-w.svg"}
                                        alt="WeNaturalists"/>
                                </div>
                            </div>
                            <div className="col-lg-9 dgmenuwrap">
                                {/* <div className="dgnav">
                                    <div className="dgnavinn">
                                        <ul id="menu" className="menu">                                            
                                            <li className="loginBtn"><Link to={"/login"}>Login</Link></li>
                                            <li className="signupBtn"><Link to={"/signup"} className="signActive">Signup</Link></li> 
                                        </ul>
                                    </div>
                                </div> */}
                                <div className="usertoppanel">                                    
                                    {this.props.notFound !== true && <i className="iHamburger"/>}
                                    <i className="iCross"
                                    style={{display: this.props.hamburgerVisibility === false ? 'none' : ''}}/>
                                </div>
                            </div>                        
                        </div>
                    </div>
                </div>
                <div className="frdsktopwithsticky">
                    <StaticHeader/>
                    {/* <div className="container d-none d-lg-block">
                        <div className="row">
                            <div className="col-md-4">
                                <Link to="/">
                                    <LazyLoadImage
                                        effect="blur"
                                        src={"https://cdn.dscovr.com/images/logoWeNaturalists.svg"}
                                        className="logotop" alt="WeNaturalists"/>
                                </Link>
                            </div>
                            <div className="col-md-8">
                                <ul className="stickymenu">
                                    <li><Link to="/explore">Explore</Link></li>
                                    <li><Link to="/causes">Causes</Link></li>
                                    <li><a href="/about-us">About Us</a></li>
                                    <li><Link to="/how-it-works">How It Works</Link></li>
                                    <li><Link to="/login">Login</Link></li>
                                    <li><Link to="/signup" className="hdrsignup active">Sign Up</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    
                    <div className="container-fluid d-lg-none nologinpage">
                        <div className="row">
                            <div className="col-md-3 col-lg-3 logowrap">
                                <div className="logotop">
                                    <LazyLoadImage
                                        effect="blur"
                                        src={"https://cdn.dscovr.com/images/logoWeNaturalists.svg"}
                                        alt="WeNaturalists"/>
                                </div>
                            </div>
                            <div className="col-lg-9 dgmenuwrap">
                                <div className="dgnav">
                                    <div className="dgnavinn">
                                        <ul id="menu" className="menu">                                            
                                            <li className="loginBtn"><Link to={"/login"}>Login</Link></li>
                                            <li className="signupBtn"><Link to={"/signup"} className="signActive">Signup</Link></li> 
                                        </ul>
                                    </div>
                                </div>
                                <div className="usertoppanel">                                    
                                    {this.props.notFound !== true && <i className="iHamburger iMeatballs"/>}
                                    <i className="iCross"
                                    style={{display: this.props.hamburgerVisibility === false ? 'none' : ''}}/>
                                </div>
                            </div>                        
                        </div>
                    </div> */}
                </div>
               <Chat/>
            </header>
            {/* <div className="mobilenav">
                <div className="bk_mobMenuOpn">
                    <span className="Mhambrgr"/>
                    <span className="Mhambrgr"/>
                    <span className="Mhambrgr"/>
                </div>
                <div className="bk_mobNavBx">
                    <div className="bk_mobMenu_clse">
                        <i className="iCross"/>
                    </div>
                    <div className="bk_mobmnulst">
                        <div className="bk_mobmnulst_cntbx">
                            <ul>
                                <li>
                                    <Link to="/" className="mLogo">
                                        <LazyLoadImage
                                            effect="blur"
                                            src={"https://cdn.dscovr.com/images/logoWeNaturalists.svg"}
                                            style={{width: '215px'}} alt="WeNaturalists"/>
                                    </Link>
                                </li>
                                <li><Link to="/explore">Explore</Link></li>
                                <li><Link to="/causes">Causes</Link></li>
                                <li><a href="/about-us">About Us</a></li>
                                <li><Link to="/how-it-works">How It Works</Link></li>
                            </ul>
                            <div className="bk_ban_btns">
                                <Link to="/signup" className="btn signup">Sign Up</Link><br/>
                                <Link to="/login" className="btn login">Log in</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    }
}

export default HeaderLanding
